<template>
  <div id="attendance-list" class=" ">
    <div class="container admin-wrap">
      <div class="row header mb-5">
        <div class="col-lg-5">
          <h3 class="text-left mb-3">{{ lang('Attendance Audit Trail') }}</h3>
        </div>
        <div class="col-lg-7">
          <div class="row searchingArea attendance-search" style="margin-bottom: 5px">
            <el-select
              v-model="ddlClass"
              :placeholder="lang('Select Class')"
              class="pro-edt-select"
              @change="LoadStudent()"
              style="margin-left: auto !important"
            >
              <el-option v-for="item in ddlClassList" :key="item.ClassID" :label="item.ClassName" :value="item.ClassID"> </el-option>
            </el-select>
          </div>
          <div class="row searchingArea attendance-search" style="margin-bottom: 5px">
            <el-select v-model="ddlStudent" :placeholder="lang('Select Student')" class="pro-edt-select" style="margin-left: auto !important">
              <el-option v-for="item in studentList" :key="item.Index_No" :label="item.First_Name + ' ' + item.Last_Name" :value="item.Index_No"> </el-option>
            </el-select>
          </div>
          <div class="row searchingArea">
            <div class="col-lg-12">
              <el-date-picker
                v-model="selectedDate"
                type="daterange"
                range-separator="-"
                :placeholder="lang('Select Date')"
                format="dd/MM/yyyy"
                value-format="dd/MM/yyyy"
              >
              </el-date-picker>
              <button type="button" class="btn btn-primary" v-on:click="Load()">
                {{ lang('View') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="pb-5">
        <div class="empty-list_image" v-if="studentList.length < 1">
          <strong v-if="hideStudentList === false">
            {{ lang('Please select Class...') }}
          </strong>
          <strong v-if="hideStudentList === true">
            {{ lang('No Student Found...') }}
          </strong>
          <img src="../assets/attendance.jpg" />
        </div>
        <div v-if="studentList.length > 0" class="responsive-table">
          <div class="divSortBy">
            <label>Sort By</label>
            <el-select v-model="sortOptionsSelected" @change="changeSort()" placeholder="Sort By" class="pro-edt-select">
              <el-option v-for="item in sortOptions" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </div>
          <table class="attTable">
            <tr>
              <th>{{ lang('Attendance Date') }}</th>
              <th>{{ lang('Attendance') }}</th>
              <th>{{ lang('Remarks') }}</th>
              <th>{{ lang('Update By') }}</th>
              <th>{{ lang('Update Date') }}</th>
            </tr>
            <tr v-for="record in attendanceAuditList" v-bind:key="record.att_aut_rn">
              <td>{{ moment(record.att_in_datetime).format('DD MMM YYYY') }}</td>
              <td>{{ record.att_status }}</td>
              <td>{{ record.att_remark }}</td>
              <td>{{ record.CONname }}</td>
              <td>{{ moment(record.att_last_updated_date).format('DD MMM YYYY h:mm A') }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataSource from '../data/datasource'
import moment from 'moment'
import { lang } from '../locale/index'
import GlobalFn from '../components/GlobalFn'
import Cookies from 'js-cookie'

export default {
  name: 'AttendanceList',
  data() {
    return {
      checkListSelect: ['Present', 'Absent', 'Late', 'Sick', 'On Holiday', 'Sent Home'],
      ddlClassList: [],
      ddlClassDetailsList: [],
      attendanceAuditList: [],
      ddlClass: '',
      ddlStudent: '',
      studentList: [],
      studentClass: [],
      studentCheck: [],
      selectedStudent: [],
      selectallStudent: false,
      bundleAttendance: false,
      hideStudentList: false,
      tempDeviceOutput: '',
      sortOptionsSelected: '',
      sortOptions: ['Attendance Date (ASC)', 'Attendance Date (DESC)', 'Update Date (ASC)', 'Update Date (DESC)'],
      selectedDate: '',
      schID: '',
      inputAdvanceClassAttendanceFromToDatePickerOptions: {
        disabledDate(time) {
          var today = new Date()
          var yesterday = new Date()
          yesterday.setDate(today.getDate() - 2)
          return !(time <= today && yesterday <= time)
        },
      },
    }
  },
  async created() {
    this.schID = Cookies.get('schoolSession')
    await this.bindClasses()
  },
  async mounted() {},
  computed: {},
  components: {
    GlobalFn,
  },
  methods: {
    lang,
    async bindClasses() {
      try {
        const response = await DataSource.shared.getAttendanceClassWithMode('GroupClasName')
        if (response) {
          this.class = response.dsGroupClass.Table
          this.class.forEach(m => {
            this.ddlClassList.push(m)
          })
          response.dsClasses.Table.forEach(m => {
            this.ddlClassDetailsList.push(m)
          })
        }
      } catch (e) {
        this.results = e
      }
    },
    async LoadStudent() {
      this.$vs.loading()
      this.ddlStudent = ''
      this.selectedDate = []
      this.attendanceAuditList = []
      let classValue = this.ddlClassDetailsList.filter(cls => {
        return cls.PK_Class_ID == this.ddlClass
      })
      console.log(this.ddlClass)
      const response = await DataSource.shared.LoadAttendanceListWithMode(this.ddlClass, 'GroupClasName')
      if (response) {
        if (response.code === '2') {
          this.studentList = []
          this.hideStudentList = true
        } else if (response.code === '99') {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Error! Please try again later'),
          })
        } else {
          this.studentList = response.Table
        }
      }
      this.$vs.loading.close()
    },
    async Load() {
      this.attendanceAuditList = []
      this.$vs.loading()
      try {
        this.sortOptionsSelected = ''
        if (this.selectedDate === '') {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Please select date'),
          })
        } else if (this.ddlClass === '') {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Please select class'),
          })
        } else if (this.ddlStudent === '') {
          this.$notify.error({
            title: lang('Error'),
            message: lang('Please select student'),
          })
        } else {
          const response = await DataSource.shared.LoadAttendanceAudit(this.selectedDate[0], this.selectedDate[1], this.ddlStudent)
          if (response) {
            if (response.code === '2') {
              this.studentList = []
              this.hideStudentList = true
            } else if (response.code === '99') {
              this.$notify.error({
                title: lang('Error'),
                message: lang('Error! Please try again later'),
              })
            } else {
              this.attendanceAuditList = response.Table
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    changeSort() {
      //sortOptions: ['Attendance Date (ASC)','Attendance Date (DESC)', 'Update Date (ASC)', 'Update Date (DESC)'],
      if (this.sortOptionsSelected === 'Attendance Date (ASC)') {
        this.attendanceAuditList = GlobalFn.SortObjectByKey(this.attendanceAuditList, 'att_in_datetime', 'asc')
      }
      if (this.sortOptionsSelected === 'Attendance Date (DESC)') {
        this.attendanceAuditList = GlobalFn.SortObjectByKey(this.attendanceAuditList, 'att_in_datetime', 'desc')
      }
      if (this.sortOptionsSelected === 'Update Date (ASC)') {
        this.attendanceAuditList = GlobalFn.SortObjectByKey(this.attendanceAuditList, 'att_last_updated_date', 'asc')
      }

      if (this.sortOptionsSelected === 'Update Date (DESC)') {
        this.attendanceAuditList = GlobalFn.SortObjectByKey(this.attendanceAuditList, 'att_last_updated_date', 'desc')
      }
    },
  },
}
</script>
<style scoped>
.attTable {
  width: 100%;
  margin-top: 20px;
}

.attTable td,
.attTable th,
.attTable label {
  text-align: center;
  padding: 10px;
}

.attTable tr:nth-child(even) {
  background: #fff;
}

.ddlClass {
  display: inline;
  width: auto;
}

.lblClass {
  display: inline !important;
  padding: 20px;
}

input[type='checkbox'] {
  width: 30px;
  height: 30px;
  background: white;
  border-radius: 5px;
  border: 2px solid #555;
}

.searchingArea {
  text-align: left;
}

.checkbox_wrapper {
  min-width: 100%;
}

.lblCheckBox {
  width: 100%;
}

.attendance-search .el-select {
  margin-left: 10px !important;
}

.lblStudentName {
  font-weight: normal !important;
}

.divSortBy {
  text-align: right;
}
.divSortBy label {
  display: inline !important;
  margin-right: 10px;
}
</style>
